module.exports = __webpack_public_path__ + "img/nick.bb9fab6b.jpg";